import { render, staticRenderFns } from "./WindowMenu.vue?vue&type=template&id=6cb2cc18&scoped=true&"
import script from "./WindowMenu.vue?vue&type=script&lang=js&"
export * from "./WindowMenu.vue?vue&type=script&lang=js&"
import style0 from "./WindowMenu.vue?vue&type=style&index=0&id=6cb2cc18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb2cc18",
  null
  
)

export default component.exports